webpackJsonp([7],{

/***/ 287:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(26)(
  /* script */
  __webpack_require__(669),
  /* template */
  __webpack_require__(778),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 667:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_constants__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__constants_constants__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DevicesList',
  props: {
    devices: {
      type: Array,
      default: []
    }
  },
  data: function data() {
    return {
      clickedDevice: {},
      STATES: __WEBPACK_IMPORTED_MODULE_0__constants_constants__["STATES"]
    };
  },

  computed: {},
  created: function created() {},

  methods: {
    openDevice: function openDevice(item) {
      mixpanel.track('Open device in list', { 'id': item.id });
      gtag('event', 'open_device_in_list', { event_category: 'click', event_label: 'Open device in list', value: item.id });
      this.$router.push({ name: 'DeviceDetail', params: { id: '' + item.id } });
    },
    getName: function getName(item) {
      if (item.orgName) {
        return item.orgName + ' - ' + item.name;
      } else {
        return item.name;
      }
    }
  }
});

/***/ }),

/***/ 668:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DevicesMap',
  data: function data() {
    return {};
  },
  created: function created() {}
});

/***/ }),

/***/ 669:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DevicesList_vue__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DevicesList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__DevicesList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DevicesMap_vue__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DevicesMap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__DevicesMap_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_graphql__ = __webpack_require__(139);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'equipments',
  components: {
    DevicesList: __WEBPACK_IMPORTED_MODULE_0__DevicesList_vue___default.a,
    DevicesMap: __WEBPACK_IMPORTED_MODULE_1__DevicesMap_vue___default.a
  },
  data: function data() {
    return {
      User: {
        Organization: {
          Device: []
        }
      },
      currentTab: 'tab-devices-list',
      tabs: [{
        name: 'devices-list',
        tabName: 'Lista',
        component: 'DevicesList',
        isDisabled: false
      }, {
        name: 'devices-map',
        tabName: 'Mapa',
        component: 'DevicesMap',
        isDisabled: true
      }]
    };
  },

  apollo: {
    User: {
      query: __WEBPACK_IMPORTED_MODULE_2__constants_graphql__["e" /* USER_QUERY */],
      variables: function variables() {
        return {
          id: this.$store.getters.user.id
        };
      }
    }
  },
  computed: {
    devices: function devices() {
      if (this.User.Organization) {
        var deviceList = [];
        var organizationList = this.User.Organization;
        if (organizationList.length) {
          organizationList.forEach(function (org) {
            var auxDevices = org.Device;
            if (auxDevices.length) {
              auxDevices.forEach(function (device, index) {
                auxDevices[index].orgName = org.name;
              });
            }
            deviceList = deviceList.concat(auxDevices);
          });
        };
        return deviceList;
      } else {
        return [];
      }
    }
  },
  methods: {},
  created: function created() {
    mixpanel.identify(this.User.id);
    mixpanel.people.set({
      '$email': this.User.email,
      '$name': this.User.name
    });
    gtag('set', 'user_properties', {
      name: this.User.name
    });
    mixpanel.track('/equipments');
    gtag('config', 'GA_MEASUREMENT_ID', {
      'page_title': 'Equipments',
      'page_path': '/equipments'
    });
  }
});

/***/ }),

/***/ 740:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(26)(
  /* script */
  __webpack_require__(667),
  /* template */
  __webpack_require__(765),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 741:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(26)(
  /* script */
  __webpack_require__(668),
  /* template */
  __webpack_require__(774),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 765:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-list', {
    staticClass: "devices-list"
  }, [_vm._l((_vm.devices), function(item) {
    return [_c('v-list-tile', {
      key: item.title,
      attrs: {
        "avatar": "",
        "append": ""
      },
      on: {
        "click": function($event) {
          return _vm.openDevice(item)
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', {
      attrs: {
        "color": _vm.$ponceConfig.checkStatus(item.Event ? item.Event.State.value : _vm.STATES.OFF)
      }
    }, [_vm._v("trip_origin")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('strong', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(_vm.getName(item))
      }
    })], 1), _vm._v(" "), (item.Crops.length) ? _c('v-list-tile-sub-title', {
      staticClass: "device-lot-name"
    }, [_vm._v(_vm._s(item.Crops[0].name))]) : _c('v-list-tile-sub-title', {
      staticClass: "device-lot-name"
    }, [_vm._v("Sin Lote")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', [_vm._v("arrow_forward_ios")])], 1)], 1)]
  })], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 774:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": ""
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 778:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-tabs', {
    attrs: {
      "centered": "",
      "color": "transparent",
      "light": "",
      "fixed-tabs": ""
    },
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('v-tabs-slider', {
    attrs: {
      "color": "#0099E1"
    }
  }), _vm._v(" "), _vm._l((_vm.tabs), function(tab) {
    return _c('v-tab', {
      key: tab.name,
      attrs: {
        "href": '#tab-' + tab.name,
        "id": tab.name,
        "disabled": tab.isDisabled
      }
    }, [_vm._v("\n    " + _vm._s(tab.tabName) + "\n  ")])
  }), _vm._v(" "), _c('v-tabs-items', {
    attrs: {
      "touchless": ""
    },
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('v-tab-item', {
      key: tab.name,
      attrs: {
        "value": 'tab-' + tab.name
      }
    }, [_c('v-card', {
      attrs: {
        "color": "transparent",
        "flat": ""
      }
    }, [_c(tab.component, {
      ref: "childComponent",
      refInFor: true,
      tag: "component",
      attrs: {
        "devices": _vm.devices
      }
    })], 1)], 1)
  }), 1)], 2)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/7.485725ccd9cb13cc805b.js